// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"4032":"e6e6f73b","8688":"84eaa2f7"}[chunkId] + "." + {"4032":"537c99eac3a84bec","8688":"8a79292820d0c5d8"}[chunkId] + ".js";
};